import { faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Style from './ForumAnswer.module.css'
const ForumAnswer = ({data}) => {
    return (
        <li className={Style.AnswerDivision}>
            <div className={Style.QuestionerInfo}>
                <FontAwesomeIcon icon={faUserCircle}/>
                <p>{data.name}</p>
                <div className={Style.ResponseInfo}>
                    <p>{data.date.split(' ')[0]}</p>
                </div>
            </div>
            <div className={Style.QuestionText}>
                <p>{data.answer}</p>
            </div>
        </li>
    )
}

export default ForumAnswer
